import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { AudioContext } from "../../contexts/AudioContext";
import { AuthContext } from "../../Auth";
import firebase from "firebase";
import "./style.scss";

export default function About() {
  const audioContext = useContext(AudioContext);
  const authContext = useContext(AuthContext);
  const history = useHistory();
  const [isLoading, setLoading] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    return () => {
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  const updateWindowDimensions = () => {
    setWidth(window.innerWidth);
  };

  const handleClickStart = () => {
    const elem = document.getElementById("root");
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE/Edge */
      elem.msRequestFullscreen();
    }

    if (authContext.currentUser) {
      setLoading(true);
      audioContext.volumeDown();
      const audio = new Audio(require("../../assets/audio/loading.mp3"));
      audio.volume = 0.5;
      audio.loop = true;
      audio.play();
      var db = firebase.firestore();
      db.collection("users")
        .doc(authContext.currentUser.email)
        .get()
        .then((doc) => {
          db.collection("users")
            .doc(authContext.currentUser.email)
            .get()
            .then((doc) => {
              if (doc.data().timeLeft) {
                setLoading(false);
                setTimeLeft(doc.data().timeLeft);
                history.push("/profile");
                audio.pause();
                audio.currentTime = 0;
                audioContext.volumeUp();
              } else {
                setLoading(false);
                setTimeLeft(0);
                history.push("/luckygame");
                audio.pause();
                audio.currentTime = 0;
                audioContext.volumeUp();
              }
            });
        });
    } else {
      history.push("/signin");
    }
  };

  return (
    <>
      {isLoading ? (
        <div className="about-loader-container">
          <img
            alt="loader"
            src={require(`../../assets/images/SVG/1.svg`)}
            className="loader"
          ></img>
          <div>
            {timeLeft > 0 ? "LOADING PROFILE..." : "LOADING LUCKY PAD..."}
          </div>
        </div>
      ) : (
        <div className="about">
          <img
            alt="logo"
            src={require("./../../assets/images/home-logo.svg")}
            className="about-logo"
          ></img>
          <div className="about-body">
            <div className="about-body-question1">How to play?</div>
            <div className="about-body-answer1">
              <div className="about-body-answer1-up">
                You start playing by selecting 7 random fields on your screen.
                <br />
                <br />
                When you do, be relaxed and choose the ones that feel lucky.
              </div>
              <img
                alt="help"
                src={require(`./../../assets/images/${
                  width > 700 ? "hand_desktop.png" : "hand.png"
                }`)}
                className="about-body-answer1-image"
                style={{ width: width + 40 }}
              ></img>
              <div className="about-body-answer1-down">
                In the picture above you can see the Lucky7 game-play.
                <br />
                <br />
                If you change your mind about a selected field, you can simply
                click on it again and it will reset the current field, while you
                can choose a new one.
                <br />
                <br />
                Once you are satisfied with your selection, press the CHECK YOUR
                LUCK.
              </div>
            </div>
            <div className="about-body-question2">How does it work?</div>
            <div className="about-body-answer2">
              <div className="about-body-answer2-question">
                Each field has a random value; from 1 to 49. The number is
                generated right before your eyes, as you press the CHECK YOUR
                LUCK.
                <br />
                <br />
                <br />
              </div>
              <div className="about-body-answer2-group1">
                <img
                  alt="human"
                  src={require("../../assets/images/human.svg")}
                  className="about-body-answer2-group1-human"
                ></img>
                <img
                  alt="logo"
                  src={require("../../assets/images/logo.svg")}
                  className="about-body-answer2-group1-logo"
                ></img>
                <img
                  alt="humans"
                  src={require("../../assets/images/humans.svg")}
                  className="about-body-answer2-group1-humans"
                ></img>
              </div>
              Your selected Lucky7 sum will be compared to the sum of all the
              people that have played before you.
              <br />
              <br />
              <div>
                To your result we will add
                <span
                  style={{
                    color: "#ffcc00",
                    fontWeight: "700",
                    marginLeft: "5px",
                  }}
                >
                  the miliseconds of time on the exact moment you finished the
                  game.
                </span>
              </div>
              <br /> This way, your luck will separate you from players who
              scored the same number as you.
              <br />
              <br />
              <br />
              <br />
              <img
                alt="lucky"
                src={require("../../assets/images/lucky.png")}
              ></img>
              <br />
              <br />
              If your Lucky7 score is <strong>above the average</strong> of
              other luck seekers, consider yourself lucky today.
              <br />
              <br />
              <br />
              <br />
              <img
                alt="lucky"
                src={require("../../assets/images/unlucky.png")}
              ></img>
              <br />
              <br />
              If your Lucky7 score is <strong>below the average</strong>, the
              luck is currently not on your side.
              <br />
              <br />
              <br />
              <br />
              <img
                alt="lucky"
                src={require("../../assets/images/timestamp.svg")}
              ></img>
              <br />
              <br />
              <strong>Milliseconds Time Stamp</strong>
              <br />
              <br />
              If your score was <strong>217</strong> and miliseconds at the
              moment you finish the game were .419 your result will be{" "}
              <strong style={{ color: "#ffcc00" }}>217</strong> +419
              miliseconds.
              <br />
              <br />
              <br />
              <br />
              <img
                alt="lucky"
                src={require("../../assets/images/calc.svg")}
              ></img>
              <br />
              <br />
              You can test your luck once per hour, every hour. <br />
              <br />
              <br />
              <br />
              <br />
              <img
                alt="lucky"
                src={require("../../assets/images/notify.svg")}
              ></img>
              <br />
              <br />
              If you wish, we will send a reminder when you can test your luck
              again.
              <br />
              <br />
              <br />
              <br />
              <strong>READY TO GET LUCKY?</strong>
            </div>
          </div>
          <div className="about-footer">
            <button className="about-footer-button" onClick={handleClickStart}>
              LET'S GO
            </button>
          </div>
        </div>
      )}
    </>
  );
}
